/**
 * @prettier
 * @flow
 */
import CssBaseline from '@material-ui/core/CssBaseline';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from 'src/App';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#2F4050',
        },
        secondary: {
            main: '#1AB393',
        },
    },
});

export function AppRoot() {
    return <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
            <App />
        </Router>
    </ThemeProvider>;
}
